import React from 'react'
import { Form, Input, Button, Modal, InputNumber } from 'antd'

const FormItem = Form.Item

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okType: 'danger',
      okText: 'Да',
      cancelText: 'Нет',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }
    const isCreateForm = this.props.type === 'create'

    return (
      <Form onSubmit={this.handleOnSubmit}>
        <FormItem label='Название' {...formItemLayout}>
          {getFieldDecorator('s_name', {
            rules: [{ required: true, message: 'Пожалуйста введите название.' }],
          })(<Input placeholder='Название' />)}
        </FormItem>

        <FormItem label='Идентификатор' {...formItemLayout}>
          {getFieldDecorator('n_identity', {
            initialValue: 0,
            rules: [{ required: true, message: 'Пожалуйста укажите идентификатор.' }],
          })(<InputNumber
            style={{ width: '100%' }}
            placeholder='Идентификатор'
            min={0}
            max={100}
            step={1}
          />)}
        </FormItem>

        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            {isCreateForm ? 'Создать' : 'Сохранить'}
          </Button>
          {
            !isCreateForm &&
            <Button
              loading={this.props.isDeleteItemLoading}
              type='danger'
              htmlType='button'
              onClick={this.handleOnDelete}
            >
              Удалить
            </Button>
          }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    return {
      s_name: Form.createFormField(formFieldValues.s_name),
      n_identity: Form.createFormField(formFieldValues.n_identity),
    }
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/RoleForm/Form.jsx